<template>
    <div id="molonez">
        <section class="welcome">
            <div class="bg"><span></span></div>
            
            <div class="start">
                <h1><span>&laquo;Молонез&raquo;:<br> <b>кисломолочный соус для ваших блюд</b></span></h1>
                <div class="text">Этот соус&nbsp;&mdash;&nbsp;уникальная и&nbsp;полезная альтернатива майонезу.   
                Производится на&nbsp;Кубани, а&nbsp;любим по&nbsp;всей стране!</div>
                <h3>Лучшая альтернатива майонезу на&nbsp;российском рынке!</h3>
                <ul>
                    <li>Никаких растительных жиров, вредных добавок и&nbsp;уксуса!</li>
                    <li>А&nbsp;калорийность и&nbsp;содержание жира значительно ниже, чем у&nbsp;майонеза.</li>
                    <li>Для легких овощных салатов и&nbsp;запекания есть &laquo;Летний Молонез&raquo;, обладающий легкой консистенцией.</li>
                    <li>А&nbsp;для таких миксов, как оливье, подойдет густой &laquo;Зимний Молонез&raquo;.</li>
                </ul>
                <div class="block">Эта полезная заправка со&nbsp;вкусом майонеза и&nbsp;пользой молока&nbsp;&mdash; находка для тех, кто заботится о&nbsp;своем здоровье и&nbsp;поддерживает себя в&nbsp;хорошей физической форме.</div>
            </div>
            <div class="list">
                <h2>Награды</h2>
                <div class="item item-img1">
                    <div class="item-content">
                        <h3>&laquo;Молонез&raquo;</h3>
                        <p>Золотая медаль &laquo;За&nbsp;качество&raquo; и&nbsp;диплом I степени на&nbsp;25-й Международной выставке продуктов питания, напитков и&nbsp;сырья для их&nbsp;производства &laquo;Продэкспо-2018&raquo;, конкурс &laquo;За&nbsp;высокие потребительские свойства&raquo;</p>
                    </div>
                </div>
            </div>
            <div class="lenta">

                <news></news>

                <!--<div class="lenta-logo"></div>-->
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "Molonez"
    }
</script>